import React from 'react';

/**
 * 搜索结果计数组件
 */
interface SearchCountProps {
    current: number;
    total: number;
}

const SearchCount: React.FC<SearchCountProps> = React.memo(({ current, total }) => (
    <div className="search-pdf-toolbar-count" aria-label={`current ${current} of ${total}`}>
        {current}/{total}
    </div>
));

SearchCount.displayName = 'SearchCount';

export { SearchCount };
export type { SearchCountProps };

